import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/leftFee.png'
import _imports_1 from '@/assets/img/home/trend-up.png'
import _imports_2 from '@/assets/img/home/trend-down.png'
import _imports_3 from '@/assets/img/home/zaibaorenshu.png'
import _imports_4 from '@/assets/img/home/teleNo.png'
import _imports_5 from '@/assets/img/home/kefu.png'


const _withScopeId = n => (_pushScopeId("data-v-b1497698"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "block detail" }
const _hoisted_5 = { class: "detail-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "账户余额", -1))
const _hoisted_7 = { class: "detail-num" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit-money" }, "¥", -1))
const _hoisted_9 = {
  key: 0,
  class: "label"
}
const _hoisted_10 = { class: "detail-footer" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "detail-icon",
    src: _imports_0
  })
], -1))
const _hoisted_12 = { class: "block detail" }
const _hoisted_13 = { class: "detail-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "当前在保人数", -1))
const _hoisted_15 = { class: "detail-num" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "人", -1))
const _hoisted_17 = { class: "detail-footer" }
const _hoisted_18 = {
  key: 0,
  class: "icon",
  src: _imports_1
}
const _hoisted_19 = {
  key: 1,
  class: "icon",
  src: _imports_2
}
const _hoisted_20 = {
  key: 0,
  class: "pie-info"
}
const _hoisted_21 = {
  ref: "miniPie",
  class: "mini-pie"
}
const _hoisted_22 = { class: "pie-legend" }
const _hoisted_23 = { class: "legend-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_25 = { class: "legend-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-yellow" }, null, -1))
const _hoisted_27 = { class: "legend-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }, null, -1))
const _hoisted_29 = {
  key: 1,
  class: "detail-right"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "detail-icon",
  src: _imports_3
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "block detail"
}
const _hoisted_33 = { class: "detail-content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, "专属客服", -1))
const _hoisted_35 = { class: "detail-num contact" }
const _hoisted_36 = {
  key: 1,
  class: "avatar"
}
const _hoisted_37 = { class: "detail-footer" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_4
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "detail-icon",
    src: _imports_5
  })
], -1))
const _hoisted_40 = { class: "form" }
const _hoisted_41 = { class: "form-row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "选择月份：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "key" }, "格式："),
  /*#__PURE__*/_createElementVNode("div", { class: "value" }, "按天")
], -1))
const _hoisted_44 = { class: "export-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.data?.notice?.title)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: _ctx.data?.notice?.title,
          type: "warning",
          "show-icon": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              style: {"white-space":"pre-wrap"},
              innerHTML: _ctx.data?.notice?.content
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.adShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_carousel, {
            style: {"width":"100%"},
            height: "9.5dvw",
            "indicator-position": "none"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ad, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      onClick: ($event: any) => (_ctx.jumpInfo(item.path)),
                      style: {"border-radius":"12px","width":"100%","cursor":"pointer"},
                      src: item.image,
                      fit: "cover"
                    }, null, 8, ["onClick", "src"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.data?.wallet?.balance), 1),
            (_ctx.data?.wallet?.warning)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.data?.wallet?.warning), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn detail-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path: '/recharge' })))
            }, "充值"),
            _createElementVNode("button", {
              class: "btn-white-blue detail-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ path: '/recharge/record' })))
            }, "充值记录 "),
            (_ctx.hasAppFeature('exportBill'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-white-blue detail-btn",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openExportBill && _ctx.openExportBill(...args)))
                }, "导出账单"))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.data?.person?.active), 1),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.data?.person?.monthCompare > 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_18))
              : (_openBlock(), _createElementBlock("img", _hoisted_19)),
            _createElementVNode("span", null, _toDisplayString(_ctx.data?.person?.monthCompare > 0 ? "上升" : "下降") + " " + _toDisplayString(Math.abs(_ctx.data?.person?.monthCompare * 100).toFixed(1)) + "% 上月同期 ", 1)
          ])
        ]),
        (_ctx.level1to3.count > 0 || _ctx.level4.count > 0 || _ctx.level5.count > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, null, 512),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, "1-3类: " + _toDisplayString(_ctx.level1to3.count) + " (" + _toDisplayString(_ctx.level1to3.ratio) + "%)", 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", null, "4类: " + _toDisplayString(_ctx.level4.count) + " (" + _toDisplayString(_ctx.level4.ratio) + "%)", 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", null, "5类: " + _toDisplayString(_ctx.level5.count) + " (" + _toDisplayString(_ctx.level5.ratio) + "%)", 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
      ]),
      (_ctx.data?.service?.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                (_ctx.data?.service?.avatar)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      class: "avatar",
                      src: _ctx.data?.service?.avatar
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.data?.service?.name.slice(0, 1)), 1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.data?.service?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("span", null, _toDisplayString(_ctx.data?.service?.mobile), 1)
              ])
            ]),
            _hoisted_39
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isExportBill)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 2,
          dataTitle: "导出账单",
          width: "480px",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isExportBill = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.billMonth,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.billMonth) = $event)),
                  class: "value",
                  type: "month",
                  placeholder: "选择月份",
                  "value-format": "YYYY-MM",
                  format: "YYYY-MM"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_43
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "btn-white",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isExportBill = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "btn btn-alone",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onExportBill && _ctx.onExportBill(...args)))
              }, "确定导出")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}